import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { authStore } from '../shared/security/AuthStore';
import { Settings } from '../components/settings/Settings';
import { Countries } from '../components/settings/countries/Countries';
import { Skills } from '../components/settings/skills/Skills';
import { Tags } from '../components/settings/tags/Tags';
import { JobRoles } from '../components/settings/job-roles/JobRoles';
import { Industries } from '../components/settings/industries/Industries';
import { ExpertiseAreas } from '../components/settings/expertise-areas/ExpertiseAreas';
import { Recruiters } from '../components/settings/recruiters/Recruiters';
import { Currencies } from '../components/settings/currencies/Currencies';
import { TestResultsFiles } from 'components/test-results-files/TestResultsFiles';
import { Locations } from 'components/settings/locations/Locations';
import { Users } from 'components/users/Users';
import { ScorecardTemplates } from 'components/settings/scorecard-templates/ScorecardTemplates';
import { ScorecardTemplateForm } from 'components/settings/scorecard-templates/ScorecardTemplateForm';
import { Tests } from 'components/settings/tests/Tests';

const SettingsRoutes = ({ match }) => {
	return (
		<div className="SettingsWrapper">
			<Route exact fullScreenLayout={false}>
				{auth(<Settings />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/countries`}>
				{auth(<Countries />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/technologies`}>
				{auth(<Skills />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/tags`}>
				{auth(<Tags />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/job-roles`}>
				{auth(<JobRoles />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/industries`}>
				{auth(<Industries />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/expertise-areas`}>
				{auth(<ExpertiseAreas />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/recruiters`}>
				{auth(<Recruiters />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/currencies`}>
				{auth(<Currencies />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/test-results-files`}>
				{auth(<TestResultsFiles />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/locations`}>
				{auth(<Locations />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/users`}>
				{auth(<Users />)}
			</Route>
			<Route
				fullScreenLayout={false}
				path={`${match.path}/scorecard-templates/:id`}
				exact>
				{auth(<ScorecardTemplateForm />)}
			</Route>
			<Route
				fullScreenLayout={false}
				path={`${match.path}/scorecard-templates`}
				exact>
				{auth(<ScorecardTemplates />)}
			</Route>
			<Route fullScreenLayout={false} path={`${match.path}/tests`}>
				{auth(<Tests />)}
			</Route>
		</div>
	);
};

function auth(component) {
	if (!authStore.isUserLogged()) {
		return <Redirect to="/login" />;
	} else {
		return component;
	}
}

export default withRouter(SettingsRoutes);
